module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pushPopup"
  }, [_c('transition', {
    attrs: {
      "name": "pushPopup-transition",
      "enter-active-class": "animate-entrance",
      "leave-active-class": "animate-exit"
    }
  }, [(_vm.isPopupShown) ? _c('div', {
    staticClass: "pushPopup__box position--box dimension--box",
    on: {
      "click": function($event) {
        _vm.closePopup()
      },
      "mouseover": function($event) {
        _vm.isHovering = true
      },
      "mouseleave": function($event) {
        _vm.isHovering = false
      }
    }
  }, [(_vm.pushPayloadMsg.data) ? [_c('div', {
    staticClass: "pushPopup__closeBtn position--closeBtn dimension--closeBtn"
  }, [_c('svg-close-popup', {
    attrs: {
      "width": "15",
      "height": "15"
    }
  })], 1), _c('component', _vm._b({
    staticClass: "dimension--inherit"
  }, 'component', _vm.linkProps(), false), [_c('div', {
    staticClass: "dimension--inherit",
    on: {
      "click": function($event) {
        _vm.updatePushVisitedList(_vm.pushPayloadMsg.data.nid)
      }
    }
  }, [_c('div', {
    staticClass: "pushPopup__col--left dimension--left position--left"
  }, [(_vm.imageUrl) ? [(_vm.articleType === 'live') ? _c('SpeechBalloonLabel', {
    attrs: {
      "node": _vm.popupNode,
      "size": "small-responsive",
      "mainComponent": "pushPopup",
      "shadow": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "pushPopup__image dimension--inherit",
    style: ({
      'background-image': ("url('" + _vm.imageUrl + "')")
    })
  })] : _vm._e()], 2), _c('div', {
    staticClass: "pushPopup__col--right dimension--right position--right"
  }, [_c('p', {
    staticClass: "pushPopup__header p--header font--large"
  }, [_vm._v("NEW ON ABACUS")]), (_vm.pushPayloadMsg.data.title) ? _c('p', {
    staticClass: "font--small hidden-320-down"
  }, [_vm._v(_vm._s(_vm._f("truncateText")(_vm.pushPayloadMsg.data.title, 87)))]) : _vm._e(), (_vm.pushPayloadMsg.data.title) ? _c('p', {
    staticClass: "font--small hidden-320-up"
  }, [_vm._v(_vm._s(_vm._f("truncateText")(_vm.pushPayloadMsg.data.title, 65)))]) : _vm._e()])])])] : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcce696","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/widgets/PushPopup.vue
// module id = 1757
// module chunks = 7